import { Component } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { environment } from 'src/environments/environment';

/**
 * Lo que ve quien entra con una cuenta que no administra.
 *
 * Casi siempre es alguien que se registró en la web para inscribirse en una carrera y ha abierto
 * la dirección del panel. No ha hecho nada malo, así que lo que toca es decirle dónde está lo
 * suyo y darle salida.
 *
 * La salida es cerrar la sesión y no «volver al inicio»: con la sesión abierta, el inicio
 * redirige al dashboard y el guardián devuelve aquí, que dejaba a la persona dando vueltas.
 */
@Component({
    selector: 'app-accessdenied',
    templateUrl: './app.accessdenied.component.html',
    styleUrls: ['./app.accessdenied.component.scss'],
    standalone: false
})
export class AppAccessdeniedComponent {
  readonly webUrl = environment.webUrl;

  leaving: boolean = false;

  constructor(private authService: AuthService) {
  }

  get email(): string {
    try {
      return JSON.parse(localStorage.getItem('user') || 'null')?.email || '';
    } catch {
      return '';
    }
  }

  signOut(): void {
    if (this.leaving) return;

    this.leaving = true;
    void this.authService.SignOut();
  }
}
